var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-100 h-100 p-0 m-0 mx-auto"},[_c('Navbar'),_c('router-view',{staticStyle:{"padding-top":"56px"}}),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }